import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

/**
 * Gate for routes restricted to specific roles. Nest INSIDE <ProtectedRoute />
 * (this assumes a session already exists — it only checks *which* role):
 *
 *   <Route element={<ProtectedRoute />}>
 *     <Route element={<RoleRoute allow={['Admin']} />}>
 *       <Route path="/role-list" element={<RoleListPage />} />
 *     </Route>
 *   </Route>
 */
export default function RoleRoute({ allow }) {
  const { user } = useAuth();
  const location = useLocation();

  if (!allow.includes(user?.role)) {
    return <Navigate to="/403" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
